// extracted by mini-css-extract-plugin
export var boxItems = "_83-1";
export var boxItemsLg = "_83-2";
export var button = "_83-7";
export var buttonHoverless = "_83-9";
export var buttonLg = "_83-8";
export var filterGroupBox = "_83-0";
export var icon = "_83-3";
export var iconSecondary = "_83-6";
export var iconWrapper = "_83-4";
export var iconWrapperLg = "_83-5";
export var truncatedLabel = "_83-a";